import { RegItem } from 'src/types/regItem'

export const getHandlePurchasedCheckboxClicked = (regItem: RegItem) => () => {
  console.log(`Purchased checkbox clicked for ${regItem.id}`)
}
